// settings-api's alias for every EU member state in its business-rule expressions.
export const EU_ALIAS_CODE = 'EU'
// The same alias as the shipping rules name it, among the country names they hold.
export const EU_ALIAS_NAME = 'European Union'

// settings-api's getEUCountries, behind its "EU" alias and orderIsFromEuropeanUnion: EL is Greece's EU
// code, and Monaco counts too.
export const EU_COUNTRIES: readonly string[] = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'EL',
  'MC'
]

export const isEuCountry = (iso: string) =>
  EU_COUNTRIES.includes(iso.toUpperCase())
